module.exports = __webpack_public_path__ + "static/img/section-4.16775e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-4.jpg
// module id = CqQ6
// module chunks = 1